(()=>{
 if(customElements.get('sw-polo-cart-preview'))return;
 class SWPoloCartPreview extends HTMLElement{
  connectedCallback(){
   if(this.ready)return;this.ready=true;
   try{this.paint(JSON.parse(this.dataset.preview))}catch{}
  }
  safeImage(source){
   if(typeof source!=='string')throw new Error('Invalid image');
   const u=new URL(source,location.href),origin=new URL(this.dataset.imageOrigin,location.href);
   if(u.protocol!=='https:'||![location.hostname,origin.hostname,'cdn.shopify.com'].includes(u.hostname))throw new Error('Invalid image origin');
   return u.href;
  }
  number(value,min,max){
   if(typeof value!=='number'||!Number.isFinite(value)||value<min||value>max)throw new Error('Invalid preview geometry');
   return value;
  }
  paint(preview){
   if(preview?.v!==1||!Array.isArray(preview.layers)||preview.layers.length>7)return;
   const fragment=document.createDocumentFragment(),base=document.createElement('img');base.src=this.safeImage(preview.base);base.alt='';base.width=800;base.height=800;fragment.append(base);
   for(const layer of preview.layers){
    const el=document.createElement('span');el.className='sw-cart-layer';
    for(const [key,property]of [['x','left'],['y','top'],['w','width'],['h','height']])el.style[property]=this.number(layer[key],0,1)*100+'%';
    if(layer.kind==='image'){
     const img=document.createElement('img');img.src=this.safeImage(layer.src);img.alt='';el.append(img);
     el.style.transform='rotate('+this.number(layer.angle,-30,30)+'deg) scale('+this.number(layer.scaleX??1,.1,2)+','+this.number(layer.scaleY??1,.1,2)+')';
     if(layer.crop){const a=layer.crop;for(const key of ['x','y'])this.number(a[key],0,1);for(const key of ['w','h'])this.number(a[key],.0001,1);el.style.overflow='hidden';img.style.cssText='position:absolute;max-width:none;max-height:none;object-fit:fill;width:'+100/a.w+'%;height:'+100/a.h+'%;left:'+(-a.x/a.w*100)+'%;top:'+(-a.y/a.h*100)+'%;'}

     if(layer.clip===1)el.style.clipPath='inset(0 25% 0 0)';
     if(layer.clip===-1)el.style.clipPath='inset(0 0 0 25%)';
    }else if(layer.kind==='text'){
     if(typeof layer.text!=='string'||layer.text.length>22)throw new Error('Invalid text');
     el.classList.add('sw-cart-text');el.style.lineHeight=[1.12,1.22,1.5].includes(layer.lineHeight)?String(layer.lineHeight):'1.12';el.textContent=layer.text;
     const rank=layer.font==='rank';el.style.fontFamily=rank?'SWAnybody,Arial,sans-serif':'SWMontserrat,Arial,sans-serif';el.style.fontWeight=rank?'900':'700';
     el.style.fontSize=this.number(layer.size,0,.13)*100+'cqw';
     if(layer.arc){
      const a=layer.arc;for(const key of ['width','height','baseline','radius','end','length','size'])this.number(a[key],0,1000);this.number(a.sweep,0,1);
      const ns='http://www.w3.org/2000/svg',svg=document.createElementNS(ns,'svg'),path=document.createElementNS(ns,'path'),text=document.createElementNS(ns,'text'),tp=document.createElementNS(ns,'textPath'),id='sw-cart-arc-'+Math.random().toString(36).slice(2);
      svg.setAttribute('viewBox',`0 0 ${a.width} ${a.height}`);svg.setAttribute('width','100%');svg.setAttribute('height','100%');path.id=id;path.setAttribute('d',`M .1 ${a.baseline} A ${a.radius} ${a.radius} 0 0 ${a.sweep} ${a.end} ${a.baseline}`);path.setAttribute('fill','none');text.setAttribute('font-size',String(a.size));text.setAttribute('fill','#ffcc00');tp.setAttribute('href','#'+id);tp.setAttribute('textLength',String(a.length));tp.setAttribute('lengthAdjust','spacingAndGlyphs');tp.textContent=layer.text;text.append(tp);svg.append(path,text);el.replaceChildren(svg);
     }

    }else throw new Error('Invalid layer');
    fragment.append(el);
   }
   this.replaceChildren(fragment);this.dataset.rendered='true';
  }
 }
 customElements.define('sw-polo-cart-preview',SWPoloCartPreview);
})();

